<template>
<!-- 省市区 -->
    <div :class="topStyle[$route.meta.keepAlive-1]">
        <div class="top-menu">
            <div class="logo fl clearfix"><img :src="$route.meta.keepAlive === 3 ? $parent.company.config.systemIndexLogo : $parent.company.config.systemOtherLogo" class="img db"/></div>
            <div class="in clearfix">
                <ul class="nav clearfix fl" v-if="$parent.isSignin">
                    <li class="nav-li url clearfix" v-for="(item,index) in $parent.iframeMenus.topMenu" :key="index" :class="item.children != '' ? 'top-user' : ''">
                        <div class="text">
                            <a class="name" :href="item.url" target="_blank" v-if="item.type == 1 && item.url != ''">{{item.menuName}}</a>
                            <router-link exact class="name" v-else-if="item.type == 2 && item.url != ''&& item.url !== '/help'" :class="$route.meta.pageType === item.pageType ? 'router-link-active' : ''" :to="{path:'/custom',query:{url:item.key,ifarm:item.url}}">{{item.menuName}}</router-link>
                            <router-link exact class="name" v-else-if="item.type == 2 && item.url == '/help'" :class="$route.meta.pageType === item.pageType ? 'router-link-active' : ''" :to="{path:'/help',query:{url:item.url}}">{{item.menuName}}</router-link>
                            <router-link  class="name" v-else-if="item.type == 0 && item.url != ''" :to="{path:item.url}" :class="activeMenu == item.url? 'router-link-onlie-active' : ''">{{item.menuName}}</router-link>
                            <a v-if="item.url === ''" href="javascript:void(0)">{{item.menuName}}</a>
                        </div>
                        <ul class="user-nav ac" v-if="item.children != ''">
                            <li v-for="(items,index) in item.children" :key="index" >
                                <a :href="items.url" target="_blank" v-if="items.type === '1'">{{items.menuName}}</a>
                                <router-link exact v-else-if="items.type === '2'" :to="{path:'/custom',query:{url:items.key}}">{{items.menuName}}</router-link>
                            </li>
                        </ul>
                    </li>
                </ul> 
                <div class="clearfix fr">
                    <div class="url saoma fl" v-if="downloadImg!==''">
                        <a href="javascript:void(0);">
                            <i class="icons sj-icon"></i>
                        </a>
                        <div class="url-fu">
                            <img :src="downloadImg" class="img db">
                            <span class="name db ac">扫码下载客户端</span>
                        </div>
                    </div>
                    <div class="url fl" v-if="!$parent.isSignin">
                        <button class="btn btn-jbblue" @click="signIn();">登录</button>
                    </div>
                    <div class="url top-user clearfix fl" v-if="$parent.isSignin">
                        <div :class="$parent.company.config.upperRightMenus.length>0?'text':'nomenu'">
                            <img :src="$parent.headImg === '' ? '/static/images/headImg.png' : $parent.headImg" class="img fl" onerror="this.src='/static/images/headImg.png'"/>
                            <span class="name">{{$parent.nickname}}</span>
                        </div>
                        <ul class="user-nav ac" v-if="$parent.company.config.upperRightMenus.length>0">
                            <li  v-for="(item,index) in $parent.company.config.upperRightMenus" :key="index">
                                <router-link v-if="item.type ===2" :to='item.url'>{{item.menuName}}</router-link>
                                <a v-else-if="$parent.company.config.logoutShow === 1&&item.type === 1" href="javascript:void(0);" @click="logOut(1);">{{item.menuName}}</a>
                            </li>
                        </ul>
                    </div> 
                </div> 
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "left",
    props: {
        downloadImg:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            topStyle:['home','','white','header'],
            activeMenu:''
        }
    },
    watch: { // 路由监听：监听路由的变化，从而做出相应操作
        $route: {
            immediate: true, // 一旦监听到路由的变化立即执行
            handler(to,from) { // 回调函数，两个参数，to：当前的组件，from：上一个组件
                if(to.path === '/competingReport'||to.path === '/customTemplate'){
                    this.activeMenu = '/competingReport';
                }else{
                    this.activeMenu = to.path;
                } 
            }
        }
    },
    mounted() {

    },
    created() {
		
    },
    methods: {
        //登录
        signIn () {
            let that = this;
            that.$parent.$refs.logins.login = {
                show:true,
                loginTips:'',
                type:1
            }
            that.username = '';
            that.password = '';
        },
        // 退出
        logOut (type) {
            let that = this;
            that.$parent.isSignin = false;
            that.$parent.loadModal(true,'正在退出...');
            that.$api.post('user/index/logout', {token:that.$utils.getCookie('xiaohuozi')}, r => {
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.$utils.removeCookie('xiaohuozi');
                    //that.$router.push({ path: '/' })
                    window.location.href="/";
                    if(type === 1){//正常退出
                        that.$utils.alertText('退出成功');
                    }
                })
            })
        },
        // 关闭消息弹框
        closeNewsmask () {
            let that = this;
            that.$parent.notceTips = false;
            let datas = {
                msgId:that.$parent.newNotice.msgId
            }
            that.$api.post('user/index/update-notice', {data:datas}, r => {
                that.$utils.returnCode(r,function(){})
            })
        }
    }
}
</script>
<style lang="">
    
</style>



// WEBPACK FOOTER //
// src/components/topMenu.vue